const GMSL_x = [
"Jan,1993",
"Jan,1993",
"Jan,1993",
"Feb,1993",
"Feb,1993",
"Feb,1993",
"Mar,1993",
"Mar,1993",
"Mar,1993",
"Apr,1993",
"Apr,1993",
"Apr,1993",
"May,1993",
"May,1993",
"May,1993",
"Jun,1993",
"Jun,1993",
"Jun,1993",
"JUL,1993",
"JUL,1993",
"JUL,1993",
"JUL,1993",
"Aug,1993",
"Aug,1993",
"Aug,1993",
"Sep,1993",
"Sep,1993",
"Sep,1993",
"Oct,1993",
"Oct,1993",
"Oct,1993",
"Nov,1993",
"Nov,1993",
"Nov,1993",
"Dec,1993",
"Dec,1993",
"Dec,1993",
"Jan,1994",
"Jan,1994",
"Jan,1994",
"Feb,1994",
"Feb,1994",
"Feb,1994",
"Mar,1994",
"Mar,1994",
"Mar,1994",
"Apr,1994",
"Apr,1994",
"Apr,1994",
"May,1994",
"May,1994",
"May,1994",
"Jun,1994",
"Jun,1994",
"Jun,1994",
"JUL,1994",
"JUL,1994",
"JUL,1994",
"Aug,1994",
"Aug,1994",
"Aug,1994",
"Sep,1994",
"Sep,1994",
"Sep,1994",
"Oct,1994",
"Oct,1994",
"Oct,1994",
"Oct,1994",
"Nov,1994",
"Nov,1994",
"Nov,1994",
"Dec,1994",
"Dec,1994",
"Dec,1994",
"Jan,1995",
"Jan,1995",
"Jan,1995",
"Feb,1995",
"Feb,1995",
"Feb,1995",
"Mar,1995",
"Mar,1995",
"Mar,1995",
"Apr,1995",
"Apr,1995",
"Apr,1995",
"May,1995",
"May,1995",
"May,1995",
"Jun,1995",
"Jun,1995",
"Jun,1995",
"JUL,1995",
"JUL,1995",
"JUL,1995",
"Aug,1995",
"Aug,1995",
"Aug,1995",
"Sep,1995",
"Sep,1995",
"Sep,1995",
"Oct,1995",
"Oct,1995",
"Oct,1995",
"Nov,1995",
"Nov,1995",
"Nov,1995",
"Dec,1995",
"Dec,1995",
"Dec,1995",
"Dec,1995",
"Jan,1996",
"Jan,1996",
"Jan,1996",
"Feb,1996",
"Feb,1996",
"Feb,1996",
"Mar,1996",
"Mar,1996",
"Mar,1996",
"Apr,1996",
"Apr,1996",
"Apr,1996",
"May,1996",
"May,1996",
"May,1996",
"Jun,1996",
"Jun,1996",
"Jun,1996",
"JUL,1996",
"JUL,1996",
"JUL,1996",
"Aug,1996",
"Aug,1996",
"Aug,1996",
"Sep,1996",
"Sep,1996",
"Sep,1996",
"Oct,1996",
"Oct,1996",
"Oct,1996",
"Nov,1996",
"Nov,1996",
"Nov,1996",
"Dec,1996",
"Dec,1996",
"Dec,1996",
"Jan,1997",
"Jan,1997",
"Jan,1997",
"Feb,1997",
"Feb,1997",
"Feb,1997",
"Feb,1997",
"Mar,1997",
"Mar,1997",
"Mar,1997",
"Apr,1997",
"Apr,1997",
"Apr,1997",
"May,1997",
"May,1997",
"May,1997",
"Jun,1997",
"Jun,1997",
"Jun,1997",
"JUL,1997",
"JUL,1997",
"JUL,1997",
"Aug,1997",
"Aug,1997",
"Aug,1997",
"Sep,1997",
"Sep,1997",
"Sep,1997",
"Oct,1997",
"Oct,1997",
"Oct,1997",
"Nov,1997",
"Nov,1997",
"Nov,1997",
"Dec,1997",
"Dec,1997",
"Dec,1997",
"Jan,1998",
"Jan,1998",
"Jan,1998",
"Feb,1998",
"Feb,1998",
"Feb,1998",
"Mar,1998",
"Mar,1998",
"Mar,1998",
"Apr,1998",
"Apr,1998",
"Apr,1998",
"May,1998",
"May,1998",
"May,1998",
"May,1998",
"Jun,1998",
"Jun,1998",
"Jun,1998",
"JUL,1998",
"JUL,1998",
"JUL,1998",
"Aug,1998",
"Aug,1998",
"Aug,1998",
"Sep,1998",
"Sep,1998",
"Sep,1998",
"Oct,1998",
"Oct,1998",
"Oct,1998",
"Nov,1998",
"Nov,1998",
"Nov,1998",
"Dec,1998",
"Dec,1998",
"Dec,1998",
"Jan,1999",
"Jan,1999",
"Jan,1999",
"Feb,1999",
"Feb,1999",
"Feb,1999",
"Mar,1999",
"Mar,1999",
"Mar,1999",
"Apr,1999",
"Apr,1999",
"Apr,1999",
"May,1999",
"May,1999",
"May,1999",
"Jun,1999",
"Jun,1999",
"Jun,1999",
"JUL,1999",
"JUL,1999",
"JUL,1999",
"JUL,1999",
"Aug,1999",
"Aug,1999",
"Aug,1999",
"Sep,1999",
"Sep,1999",
"Sep,1999",
"Oct,1999",
"Oct,1999",
"Oct,1999",
"Nov,1999",
"Nov,1999",
"Nov,1999",
"Dec,1999",
"Dec,1999",
"Dec,1999",
"Jan,2000",
"Jan,2000",
"Jan,2000",
"Feb,2000",
"Feb,2000",
"Feb,2000",
"Mar,2000",
"Mar,2000",
"Mar,2000",
"Apr,2000",
"Apr,2000",
"Apr,2000",
"May,2000",
"May,2000",
"May,2000",
"Jun,2000",
"Jun,2000",
"Jun,2000",
"JUL,2000",
"JUL,2000",
"JUL,2000",
"Aug,2000",
"Aug,2000",
"Aug,2000",
"Sep,2000",
"Sep,2000",
"Sep,2000",
"Sep,2000",
"Oct,2000",
"Oct,2000",
"Oct,2000",
"Nov,2000",
"Nov,2000",
"Nov,2000",
"Dec,2000",
"Dec,2000",
"Dec,2000",
"Jan,2001",
"Jan,2001",
"Jan,2001",
"Feb,2001",
"Feb,2001",
"Feb,2001",
"Mar,2001",
"Mar,2001",
"Mar,2001",
"Apr,2001",
"Apr,2001",
"Apr,2001",
"May,2001",
"May,2001",
"May,2001",
"Jun,2001",
"Jun,2001",
"Jun,2001",
"JUL,2001",
"JUL,2001",
"JUL,2001",
"Aug,2001",
"Aug,2001",
"Aug,2001",
"Sep,2001",
"Sep,2001",
"Sep,2001",
"Oct,2001",
"Oct,2001",
"Oct,2001",
"Nov,2001",
"Nov,2001",
"Nov,2001",
"Nov,2001",
"Dec,2001",
"Dec,2001",
"Dec,2001",
"Jan,2002",
"Jan,2002",
"Jan,2002",
"Feb,2002",
"Feb,2002",
"Feb,2002",
"Mar,2002",
"Mar,2002",
"Mar,2002",
"Apr,2002",
"Apr,2002",
"Apr,2002",
"May,2002",
"May,2002",
"May,2002",
"Jun,2002",
"Jun,2002",
"Jun,2002",
"JUL,2002",
"JUL,2002",
"JUL,2002",
"Aug,2002",
"Aug,2002",
"Aug,2002",
"Sep,2002",
"Sep,2002",
"Sep,2002",
"Oct,2002",
"Oct,2002",
"Oct,2002",
"Nov,2002",
"Nov,2002",
"Nov,2002",
"Dec,2002",
"Dec,2002",
"Dec,2002",
"Jan,2003",
"Jan,2003",
"Jan,2003",
"Feb,2003",
"Feb,2003",
"Feb,2003",
"Feb,2003",
"Mar,2003",
"Mar,2003",
"Mar,2003",
"Apr,2003",
"Apr,2003",
"Apr,2003",
"May,2003",
"May,2003",
"May,2003",
"Jun,2003",
"Jun,2003",
"Jun,2003",
"JUL,2003",
"JUL,2003",
"JUL,2003",
"Aug,2003",
"Aug,2003",
"Aug,2003",
"Sep,2003",
"Sep,2003",
"Sep,2003",
"Oct,2003",
"Oct,2003",
"Oct,2003",
"Nov,2003",
"Nov,2003",
"Nov,2003",
"Dec,2003",
"Dec,2003",
"Dec,2003",
"Jan,2004",
"Jan,2004",
"Jan,2004",
"Feb,2004",
"Feb,2004",
"Feb,2004",
"Mar,2004",
"Mar,2004",
"Mar,2004",
"Apr,2004",
"Apr,2004",
"Apr,2004",
"May,2004",
"May,2004",
"May,2004",
"May,2004",
"Jun,2004",
"Jun,2004",
"Jun,2004",
"JUL,2004",
"JUL,2004",
"JUL,2004",
"Aug,2004",
"Aug,2004",
"Aug,2004",
"Sep,2004",
"Sep,2004",
"Sep,2004",
"Oct,2004",
"Oct,2004",
"Oct,2004",
"Nov,2004",
"Nov,2004",
"Nov,2004",
"Dec,2004",
"Dec,2004",
"Dec,2004",
"Jan,2005",
"Jan,2005",
"Jan,2005",
"Feb,2005",
"Feb,2005",
"Feb,2005",
"Mar,2005",
"Mar,2005",
"Mar,2005",
"Apr,2005",
"Apr,2005",
"Apr,2005",
"May,2005",
"May,2005",
"May,2005",
"Jun,2005",
"Jun,2005",
"Jun,2005",
"Jun,2005",
"JUL,2005",
"JUL,2005",
"JUL,2005",
"Aug,2005",
"Aug,2005",
"Aug,2005",
"Sep,2005",
"Sep,2005",
"Sep,2005",
"Oct,2005",
"Oct,2005",
"Oct,2005",
"Nov,2005",
"Nov,2005",
"Nov,2005",
"Dec,2005",
"Dec,2005",
"Dec,2005",
"Jan,2006",
"Jan,2006",
"Jan,2006",
"Feb,2006",
"Feb,2006",
"Feb,2006",
"Mar,2006",
"Mar,2006",
"Mar,2006",
"Apr,2006",
"Apr,2006",
"Apr,2006",
"May,2006",
"May,2006",
"May,2006",
"Jun,2006",
"Jun,2006",
"Jun,2006",
"JUL,2006",
"JUL,2006",
"JUL,2006",
"Aug,2006",
"Aug,2006",
"Aug,2006",
"Sep,2006",
"Sep,2006",
"Sep,2006",
"Sep,2006",
"Oct,2006",
"Oct,2006",
"Oct,2006",
"Nov,2006",
"Nov,2006",
"Dec,2006",
"Dec,2006",
"Dec,2006",
"Jan,2007",
"Jan,2007",
"Jan,2007",
"Feb,2007",
"Feb,2007",
"Feb,2007",
"Mar,2007",
"Mar,2007",
"Mar,2007",
"Apr,2007",
"Apr,2007",
"Apr,2007",
"May,2007",
"May,2007",
"May,2007",
"Jun,2007",
"Jun,2007",
"Jun,2007",
"JUL,2007",
"JUL,2007",
"JUL,2007",
"Aug,2007",
"Aug,2007",
"Aug,2007",
"Sep,2007",
"Sep,2007",
"Sep,2007",
"Oct,2007",
"Oct,2007",
"Oct,2007",
"Nov,2007",
"Nov,2007",
"Nov,2007",
"Dec,2007",
"Dec,2007",
"Dec,2007",
"Dec,2007",
"Jan,2008",
"Jan,2008",
"Jan,2008",
"Feb,2008",
"Feb,2008",
"Feb,2008",
"Mar,2008",
"Mar,2008",
"Mar,2008",
"Apr,2008",
"Apr,2008",
"Apr,2008",
"May,2008",
"May,2008",
"May,2008",
"Jun,2008",
"Jun,2008",
"Jun,2008",
"JUL,2008",
"JUL,2008",
"JUL,2008",
"Aug,2008",
"Aug,2008",
"Aug,2008",
"Sep,2008",
"Sep,2008",
"Sep,2008",
"Oct,2008",
"Oct,2008",
"Oct,2008",
"Nov,2008",
"Nov,2008",
"Nov,2008",
"Dec,2008",
"Dec,2008",
"Dec,2008",
"Jan,2009",
"Jan,2009",
"Jan,2009",
"Jan,2009",
"Feb,2009",
"Feb,2009",
"Feb,2009",
"Mar,2009",
"Mar,2009",
"Mar,2009",
"Apr,2009",
"Apr,2009",
"Apr,2009",
"May,2009",
"May,2009",
"May,2009",
"Jun,2009",
"Jun,2009",
"Jun,2009",
"JUL,2009",
"JUL,2009",
"JUL,2009",
"Aug,2009",
"Aug,2009",
"Aug,2009",
"Sep,2009",
"Sep,2009",
"Sep,2009",
"Oct,2009",
"Oct,2009",
"Oct,2009",
"Nov,2009",
"Nov,2009",
"Nov,2009",
"Dec,2009",
"Dec,2009",
"Dec,2009",
"Jan,2010",
"Jan,2010",
"Jan,2010",
"Feb,2010",
"Feb,2010",
"Feb,2010",
"Mar,2010",
"Mar,2010",
"Mar,2010",
"Apr,2010",
"Apr,2010",
"Apr,2010",
"Apr,2010",
"May,2010",
"May,2010",
"May,2010",
"Jun,2010",
"Jun,2010",
"Jun,2010",
"JUL,2010",
"JUL,2010",
"JUL,2010",
"Aug,2010",
"Aug,2010",
"Aug,2010",
"Sep,2010",
"Sep,2010",
"Sep,2010",
"Oct,2010",
"Oct,2010",
"Oct,2010",
"Nov,2010",
"Nov,2010",
"Nov,2010",
"Dec,2010",
"Dec,2010",
"Dec,2010",
"Jan,2011",
"Jan,2011",
"Jan,2011",
"Feb,2011",
"Feb,2011",
"Feb,2011",
"Mar,2011",
"Mar,2011",
"Mar,2011",
"Apr,2011",
"Apr,2011",
"Apr,2011",
"May,2011",
"May,2011",
"May,2011",
"Jun,2011",
"Jun,2011",
"Jun,2011",
"JUL,2011",
"JUL,2011",
"JUL,2011",
"JUL,2011",
"Aug,2011",
"Aug,2011",
"Aug,2011",
"Sep,2011",
"Sep,2011",
"Sep,2011",
"Oct,2011",
"Oct,2011",
"Oct,2011",
"Nov,2011",
"Nov,2011",
"Nov,2011",
"Dec,2011",
"Dec,2011",
"Dec,2011",
"Jan,2012",
"Jan,2012",
"Jan,2012",
"Feb,2012",
"Feb,2012",
"Feb,2012",
"Mar,2012",
"Mar,2012",
"Mar,2012",
"Apr,2012",
"Apr,2012",
"Apr,2012",
"May,2012",
"May,2012",
"May,2012",
"Jun,2012",
"Jun,2012",
"Jun,2012",
"JUL,2012",
"JUL,2012",
"JUL,2012",
"Aug,2012",
"Aug,2012",
"Aug,2012",
"Sep,2012",
"Sep,2012",
"Sep,2012",
"Sep,2012",
"Oct,2012",
"Oct,2012",
"Oct,2012",
"Nov,2012",
"Nov,2012",
"Nov,2012",
"Dec,2012",
"Dec,2012",
"Dec,2012",
"Jan,2013",
"Jan,2013",
"Jan,2013",
"Feb,2013",
"Feb,2013",
"Feb,2013",
"Mar,2013",
"Mar,2013",
"Mar,2013",
"Apr,2013",
"Apr,2013",
"Apr,2013",
"May,2013",
"May,2013",
"May,2013",
"Jun,2013",
"Jun,2013",
"Jun,2013",
"JUL,2013",
"JUL,2013",
"JUL,2013",
"Aug,2013",
"Aug,2013",
"Aug,2013",
"Sep,2013",
"Sep,2013",
"Sep,2013",
"Oct,2013",
"Oct,2013",
"Oct,2013",
"Nov,2013",
"Nov,2013",
"Nov,2013",
"Nov,2013",
"Dec,2013",
"Dec,2013",
"Dec,2013",
"Jan,2014",
"Jan,2014",
"Jan,2014",
"Feb,2014",
"Feb,2014",
"Feb,2014",
"Mar,2014",
"Mar,2014",
"Mar,2014",
"Apr,2014",
"Apr,2014",
"Apr,2014",
"May,2014",
"May,2014",
"May,2014",
"Jun,2014",
"Jun,2014",
"Jun,2014",
"JUL,2014",
"JUL,2014",
"JUL,2014",
"Aug,2014",
"Aug,2014",
"Aug,2014",
"Sep,2014",
"Sep,2014",
"Sep,2014",
"Oct,2014",
"Oct,2014",
"Oct,2014",
"Nov,2014",
"Nov,2014",
"Nov,2014",
"Dec,2014",
"Dec,2014",
"Dec,2014",
"Jan,2015",
"Jan,2015",
"Jan,2015",
"Feb,2015",
"Feb,2015",
"Feb,2015",
"Feb,2015",
"Mar,2015",
"Mar,2015",
"Mar,2015",
"Apr,2015",
"Apr,2015",
"Apr,2015",
"May,2015",
"May,2015",
"May,2015",
"Jun,2015",
"Jun,2015",
"Jun,2015",
"JUL,2015",
"JUL,2015",
"JUL,2015",
"Aug,2015",
"Aug,2015",
"Aug,2015",
"Sep,2015",
"Sep,2015",
"Sep,2015",
"Oct,2015",
"Oct,2015",
"Oct,2015",
"Nov,2015",
"Nov,2015",
"Nov,2015",
"Dec,2015",
"Dec,2015",
"Dec,2015",
"Jan,2016",
"Jan,2016",
"Jan,2016",
"Feb,2016",
"Feb,2016",
"Feb,2016",
"Mar,2016",
"Mar,2016",
"Mar,2016",
"Apr,2016",
"Apr,2016",
"Apr,2016",
"Apr,2016",
"May,2016",
"May,2016",
"May,2016",
"Jun,2016",
"Jun,2016",
"Jun,2016",
"JUL,2016",
"JUL,2016",
"JUL,2016",
"Aug,2016",
"Aug,2016",
"Aug,2016",
"Sep,2016",
"Sep,2016",
"Sep,2016",
"Oct,2016",
"Oct,2016",
"Oct,2016",
"Nov,2016",
"Nov,2016",
"Nov,2016",
"Dec,2016",
"Dec,2016",
"Dec,2016",
"Jan,2017",
"Jan,2017",
"Jan,2017",
"Feb,2017",
"Feb,2017",
"Feb,2017",
"Mar,2017",
"Mar,2017",
"Mar,2017",
"Apr,2017",
"Apr,2017",
"Apr,2017",
"May,2017",
"May,2017",
"May,2017",
"Jun,2017",
"Jun,2017",
"Jun,2017",
"Jun,2017",
"JUL,2017",
"JUL,2017",
"JUL,2017",
"Aug,2017",
"Aug,2017",
"Aug,2017",
"Sep,2017",
"Sep,2017",
"Sep,2017",
"Oct,2017",
"Oct,2017",
"Oct,2017",
"Nov,2017",
"Nov,2017",
"Nov,2017",
"Dec,2017",
"Dec,2017",
"Dec,2017",
"Jan,2018",
"Jan,2018",
"Jan,2018",
"Feb,2018",
"Feb,2018",
"Feb,2018",
"Mar,2018",
"Mar,2018",
"Mar,2018",
"Apr,2018",
"Apr,2018",
"Apr,2018",
"May,2018",
"May,2018",
"May,2018",
"Jun,2018",
"Jun,2018",
"Jun,2018",
"JUL,2018",
"JUL,2018",
"JUL,2018",
"Aug,2018",
"Aug,2018",
"Aug,2018",
"Sep,2018",
"Sep,2018",
"Sep,2018",
"Sep,2018",
"Oct,2018",
"Oct,2018",
"Oct,2018",
"Nov,2018",
"Nov,2018",
"Nov,2018",
"Dec,2018",
"Dec,2018",
"Dec,2018",
"Jan,2019",
"Jan,2019",
"Jan,2019",
"Feb,2019",
"Feb,2019",
"Feb,2019",
"Mar,2019",
"Mar,2019",
"Mar,2019",
"Apr,2019",
"Apr,2019",
"Apr,2019",
"May,2019",
"May,2019",
"May,2019",
"Jun,2019",
"Jun,2019",
"Jun,2019",
"JUL,2019",
"JUL,2019",
"JUL,2019",
"Aug,2019",
"Aug,2019",
"Aug,2019",
"Sep,2019",
"Sep,2019",
"Sep,2019",
"Oct,2019",
"Oct,2019",
"Oct,2019",
"Nov,2019",
"Nov,2019",
"Nov,2019",
"Dec,2019",
"Dec,2019",
"Dec,2019",
"Dec,2019",
"Jan,2020",
"Jan,2020",
"Jan,2020",
"Feb,2020",
"Feb,2020",
"Feb,2020",
"Mar,2020",
"Mar,2020",
"Mar,2020",
"Apr,2020",
"Apr,2020",
"Apr,2020",
"May,2020",
"May,2020",
"May,2020",
"Jun,2020",
"Jun,2020",
"Jun,2020",
"JUL,2020",
"JUL,2020",
"JUL,2020",
"Aug,2020",
"Aug,2020",
"Aug,2020",
"Sep,2020",
"Sep,2020",
"Sep,2020",
"Oct,2020",
"Oct,2020",
"Oct,2020",
"Nov,2020",
"Nov,2020",
"Nov,2020",
"Dec,2020",
"Dec,2020",
"Dec,2020",
"Jan,2021",
"Jan,2021",
"Jan,2021",
"Jan,2021",
"Feb,2021",
"Feb,2021",
"Feb,2021",
"Mar,2021",
"Mar,2021",
"Mar,2021",
"Apr,2021",
"Apr,2021",
"Apr,2021",
"May,2021",
"May,2021",
"May,2021",
"Jun,2021",
"Jun,2021",
"Jun,2021",
"JUL,2021",
"JUL,2021",
"JUL,2021",
"Aug,2021",
"Aug,2021",
"Aug,2021",
"Sep,2021",
"Sep,2021",
"Sep,2021",
"Oct,2021",
"Oct,2021",
"Oct,2021",
"Nov,2021",
"Nov,2021",
"Nov,2021",
"Dec,2021",
"Dec,2021",
"Dec,2021",
"Jan,2022",
"Jan,2022",
"Jan,2022",
"Feb,2022",
"Feb,2022",
"Feb,2022",
"Mar,2022",
"Mar,2022",
"Mar,2022",
"Apr,2022",
"Apr,2022",
"Apr,2022",
"Apr,2022",
"May,2022",
"May,2022",
"May,2022",
"Jun,2022",
"Jun,2022",
"Jun,2022",
"JUL,2022",
"JUL,2022",
"JUL,2022"
]

export default GMSL_x;